import { contactUsConstants } from '../MyAccount/myaccount.constants';
import {commonEnvVariables} from '@/commonEnvVariables';


const envVariables = commonEnvVariables();
export const loginConstants = {
    componentNames: {
        defaultForm: {
            component: 'LoginDefaultForm',
            title: '',
        },
        forgotUsername: {
            component: 'ForgotUsername',
            title: 'Recover Username',
        },
        forgotPassword: {
            component: 'ForgotPassword',
            title: 'Reset Password',
        },
        recoveryOptions: {
            component: 'RecoveryOptions',
            title: 'Reset Password',
        },
        recoveryCodeForm: {
            component: 'RecoveryCodeForm',
            title: 'Reset Password',
        },
        usernameFurtherAssistance: {
            component: 'UsernameFurtherAssistance',
            title: 'Recover Username',
        },
        passwordFurtherAssistance: {
            component: 'PasswordFurtherAssistance',
            title: 'Reset Password',
        },
        usernameRecoveryOptions: {
            component: 'UsernameRecoveryOptions',
            title: 'Recover Username',
        },
        selectTypePasswordDelivery: {
            component: 'SelectTypePasswordDelivery',
            title: 'Reset Password',
        },
        passwordCodeSent: {
            component: 'PasswordCodeSent',
            title: 'Reset Password',
        },
        enterPasswordResetCode: {
            component: 'EnterPasswordResetCode',
            title: 'Reset Password',
        },
        resetPassword: {
            component: 'ResetPassword',
            title: 'Reset Password',
        },
        resetPasswordConfirmationSent: {
            component: 'ResetPasswordConfirmationSent',
            title: 'Success',
        },
        accountLockout: {
            component: 'AccountLockout',
            title: "You're Locked Out!",
        },
        furtherSecurity: {
            component: 'FurtherSecurity',
            title: 'Additional Security',
        },
        contactUsForFurtherAssistance: {
            component: 'ContactUsForFurtherAssistance',
            title: null,
        },
        spousePartnerUsernameRecovery: {
            component: 'SpousePartnerUsernameRecovery',
            title: 'Recover Username',
        },
        spousePartnerResetPassword: {
            component: 'SpousePartnerResetPassword',
            title: 'Reset Password',
        },
        PrivacyPolicy: {
            component: 'PrivacyPolicy',
            title: 'Take a moment',
        },
    },
    externalLinks: {
        privacy: {
            DISPLAY_NAME: 'Privacy',
            DB_NAME: 'Privacy Policy',
            LINK:
            `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/YPO_Connect_Privacy_Policy.pdf`,
            gaTagName:'C_Login_Privacy',
        },
        termsOfUse: {
            DISPLAY_NAME: 'Terms of Use',
            DB_NAME: 'Terms of Use',
            LINK:
            `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/YPO_Connect_Terms_of_Use.pdf`,
            gaTagName:'C_Login_Terms',
        },
        cookiePolicy: {
            DISPLAY_NAME: 'Cookie Policy',
            DB_NAME: 'Cookie Policy',
            LINK:
            `${envVariables.BLOB_CDN_END_POINT}/publiclyaccessiblefiles/YPO_Cookie_Policy.pdf`,
        },
    },
    errors: {
        USERNAME_REQUIRED: 'Username is required',
        PASSWORD_REQUIRED: 'Password is required',
        EMAIL_REQUIRED: `<i class="fas fa-exclamation-circle"></i> <span>Please enter an email</span>`,
        DATE_IS_REQUIRED: 'Date is required',
        MONTH_IS_REQUIRED: 'Month is required',
        YEAR_IS_REQUIRED: 'Year is required',
        LAST_NAME_IS_REQUIRED: `<i class="fas fa-exclamation-circle"></i> <span> Please enter a last name </span>`,
        FIRST_NAME_IS_REQUIRED: `<i class="fas fa-exclamation-circle"></i> <span> Please enter a first name </span>`,
        DATE_RANGE_ERROR: 'Date must be between 1 - 31',
        MONTH_RANGE_ERROR: 'Month must be between 1 - 12',
        YEAR_RANGE_ERROR: `Year must be less than ${new Date().getFullYear()}`,
        INVALID_EMAIL: `<i class="fas fa-exclamation-circle"></i> <span> Please enter a valid email </span>`,
        PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
        BIRTHDATE_REQUIRED: 'Birth Date is required',
        COUNTRY_CODE_REQUIRED: `<i class="fas fa-exclamation-circle"></i> <span> Please enter a country code </span>`,
        COUNTRY_CODE_TYPE_ERROR: 'Country Code has to be a number',
        COUNTRY_CODE_LENGTH_ERROR: 'Country Code must be 3 or less',
        PHONE_NUMBER_REQUIRED: ` <i class="fas fa-exclamation-circle"></i> <span>Please enter a phone number </span>`,
        PHONE_NUMBER_TYPE_ERROR: 'Phone Number can only contain numbers and alphabets',
        PHONE_NUMBER_LENGTH_ERROR: 'Phone Number must be 20 or less',
        INVALID_PLEASE_RETRY: 'Invalid: Please try again',
        NOT_ABLE_TO_VALIDATE_MESSAGE:
            'We apologize for not being able to validate your information. Please contact us for further assistance.',
    },
    recoveryValues: {
        sms: 'sms',
        email: 'email',
    },
    LOGIN_DEFAULT_TITLE: "Log into YPO Connect and other global services.",
    ISSpeakerEmail: 'ask@ypo.org',
    PASSWORD: 'Password',
    USERNAME: 'Username',
    LOGIN: 'Log In',
    FORGOT_USERNAME: 'Forgot Username?',
    FORGOT_PASSWORD: 'Forgot Password?',
    EMAIL_RESET: 'Not sure which email to use?',
    USERNAME_ASSISTANCE_MAIL: 'If you are unable to recover your username above, message us at ',
    PASSWORD_ASSISTANCE_MAIL: 'Need assistance resetting your password?',
    YPO_HELP_EMAIL: 'concierge@ypo.org',
    RETURN_TO_LOGIN: 'Return to Log in',
    CANCEL: 'CANCEL',
    SUBMIT: 'Continue',
    ENTER_CODE: 'Enter Code',
    //EMAIL_PLACEHOLDER_PASSWORD_RESET: 'email',
    EMAIL_PLACEHOLDER_PASSWORD_RESET: 'Enter Address',
    //EMAIL_ASSOCIATED_WITH_YPO: "Please enter the email associated with your YPO account",
    EMAIL_ASSOCIATED_WITH_YPO: 'At what address do you receive YPO email?',
    PASSWORD_RESET_TITLE: 'Reset Password',
    REQUEST_NEW_RECOVERY_LINK: 'Request new recovery link',
    WHERE_TO_SEND_PASSWORD_RESET_CODE: 'Where would you like us to send a Password Reset Code?',
    //ENTER_REQUIRED_INFO: 'Please enter the required information below',
    ENTER_REQUIRED_INFO: 'Please answer these security questions',
    ADDITIONAL_SECURITY_NEEDED_SUBTITLE: 'We need additional information to validate your account',
    USERNAME_EMAIL_SUCCESS_1: "We have emailed your username at ",
    USERNAME_EMAIL_SUCCESS_2: ' if it is on file',
    PASSWORD_EMAIL_SUCCESS: "We've sent an email with your password to ",
    PASSWORD_RECEIVING_TYPE: 'Where would you like us to send a Password Reset Code?',
    RECOVERY_CODE_SUCCESS: 'Recovery code has been sent to ',
    RESEND_EMAIL: 'Resend Email',
    RESEND_CODE: 'Resend Code',
    VERIFICATION_CODE_LABEL: 'Enter verification code',
    NEED_FURTHER_ASSISTANCE: 'Need Further Assistance?',
    DATE_OF_BIRTH: 'Date of Birth',
    MEMBERS_DATE_OF_BIRTH: "Member's Date of Birth",
    PLACEHOLDER_BIRTH_DAY: 'DD',
    PLACEHOLDER_BIRTH_MONTH: 'MM',
    PLACEHOLDER_BIRTH_YEAR: 'YYYY',
    LAST_NAME: 'Last Name',
    FIRST_NAME: 'First Name',
    USERNAME_ASSISTANCE_SECURITY_INFO: 'Please answer these security questions',
    WHERE_TO_SEND_USERNAME_RESET_CODE: 'Where would you like us to send your Username to?',
    AND: ' and ',
    MEMBERS_LAST_NAME: "Member's Last Name",
    OR_TEXT: 'OR',
    YPO: 'YPO ',
    STANDARD_BILING: '* Standard billing charges will apply',
    PASSWORD_CODE_SUCCESS_1: 'Instructions to reset your password were sent to',
    //PASSWORD_CODE_SUCCESS_2_OLD: 'with a link to reset your password',
    PASSWORD_CODE_SUCCESS_2: 'with your identification code',
    RESEND: 'Resend',
    DID_NOT_RECEIVE_EMAIL_TEXT: "Didn't receive the email?",
    CODE: 'Code',
    ENTER_PASSWORD_MEETS_CRITERIA: 'Please enter a new password that meets these criteria',
    PASSWORD_RESET_TOKEN_INVALID: 'You have accessed an account recovery link that has expired or been previously used',
    RESET_NEW_PASSWORD: 'New Password',
    RESET_CONFIRM_NEW_PASSWORD: 'Confirm New Password',
    UPPERCASE: 'Upper Case',
    LOWERCASE: 'Lower Case',
    NUMBER_OR_SPECIAL_CHARACTERS: 'Number or Special Characters',
    TOTAL_CHARACTERS: 'Characters Total',
    TOTAL_CHARACTERS_COUNT: '10',
    MANDATORY_COUNT: '1',
    RESET_PASSWORD_CONFIRMATION_MESSAGE: 'Your password has been successfully changed',
    ASTERIK: '*',
    COUNTRY_CODE: 'Country Code',
    PHONE_NUMBER: 'Phone Number',
    MAXIMUM_LENGTH_FOR_COUNTRY_CODE: 3,
    MAXIMUM_LENGTH_FOR_PHONE_NUMBER: 20,
    MAXIMUM_ATTEMPTS_FOR_ADDITIONAL_SECURITY: 3,
    MAXIMUM_ATTEMPTS_FOR_SPOUSE_LOGIN_ASSISTANCE: 3,
    ARE_YOU_SPOUSE_PARTNER: 'Spouse/Partner of a member?',
    SPOUSE_PARTNER_PASSWORD_ASSISTANCE_LINK: 'Click here for Password assistance',
    SPOUSE_PARTNER_USERNAME_RECOVERY_LINK: 'Click here for Username recovery',
    PRIMARY_MEMBER_PHONE_NUMBER: 'Phone number of the Primary Member',
    PASSWORD_RESET_FURTHER_HELP: `If you did not receive instructions to reset your password, please contact 
            <a style="color: white" href="mailto:ask@ypo.org?subject=Please reset my YPO password">ask@ypo.org</a>.
            <p>We are happy to help you connect.</p>`,

    privacyPolicy: {
        TEXT_PART1: 'I have read and agree to the',
        TEXT_PART2: 'YPO Privacy Policy',
        TEXT_PART3: 'and',
        TEXT_PART4: 'Terms of Use.',
        TEXT_PART5: 'Resource Directory Terms of Use.',
        TAKE_MOMENT: 'Please take a moment',
    },

    accountLockout: {
        ACCOUNT_LOCKOUT_MESSAGE: 'Your account is temporarily locked for 10 minutes.',
        ACCOUNT_ASSISTANCE_MESSAGE: 'For immediate assistance, call',
        LOCKED_OUT_STATUS: 'LOCKED_OUT',
    },

    contactUs: {
        CONTACT_US_LINK: 'Contact Us',
        MEMBER_SERVICES_NUMBER: contactUsConstants.MEMBER_SERVICES_NUMBER,
        MEMBER_SERVICE_EMAIL: contactUsConstants.SUPPORT_EMAIL,
        types: {
            EMAIL: 'email',
            PHONE: 'phone',
        },
        contactTypes: [
            {
                title: 'Email',
                detail: contactUsConstants.SUPPORT_EMAIL,
                type: 'email',
                gaTagName:'C_Login_ContactUs_Email',
            },
            {
                title: 'M2Mx',
                detail: 'm2mx@ypo.org',
                type: 'email',
                gaTagName:'C_Login_ContactUs_M2Mx',
            },
            {
                title: 'United States and Canada',
                detail: contactUsConstants.MEMBER_SERVICES_NUMBER,
                type: 'phone',
            },
        ],
        speakerContactTypes: [
            {
                title: 'Email',
                detail: 'membership@ypo.org',
                type: 'email',
            },
            {
                title: 'United States and Canada',
                detail: contactUsConstants.MEMBER_SERVICES_NUMBER,
                type: 'phone',
            },
        ],
    },

    spousePartnerLoginAssistance: {
        PASSWORD: 'password',
        USERNAME: 'username',
    },

    localStorage: {
        YPO_USER_NAME_REMEMBERED: 'ypoUsernameRememberedYPO3.0',
        OKTA_CACHE_STORAGE: 'okta-cache-storage',
        OKTA_TOKEN_STORAGE: 'okta-token-storage',
    },
};
